import styled from "styled-components";

export const TableAccountingStyled = styled.div`
  width: 100%;
  overflow: visible;

  .table_scroll_x {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
  }
  .month_title {
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    margin-bottom: 12px;
  }
  
  .table_accounting {
    width: 100%;
    min-width: max-content;
    border-collapse: collapse;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
    
    .table_header {
      background: ${({ theme }) => theme.COLORS.PURPLE_5};
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
      color: ${({ theme }) => theme.COLORS.WHITE};
      padding: 8px 4px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      white-space: nowrap;
      text-align: center;
      
      &.type_col {
        width: 40px;
      }
      
      &:nth-child(2) {
        min-width: 180px;
      }
    }
    
    .table_detail {
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
      padding: 4px 8px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      background: white;
      
      &.type_col {
        text-align: center;
        width: 40px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      
      &.sub_label {
        padding-left: 20px;
      }
      
      &.bold_black {
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      
      &.text_right {
        text-align: right;
      }
      
      &.spacer {
        height: 12px;
        background: ${({ theme }) => theme.COLORS.GRAY_10 || "#f5f5f5"};
        border-left: none;
        border-right: none;
      }
    }
    
    .section_title_row {
      .table_detail {
        background: ${({ theme }) => theme.COLORS.PURPLE_8 || "#f3e8ff"};
      }
    }
    
    .spacer_row {
      .table_detail {
        border-top: none;
        border-bottom: none;
      }
    }
  }

`;
